import React, { Component } from "react";
import PropTypes from "prop-types";
import t from "babel-plugin-yate/macro";
import { connect } from "react-redux";
import { Form, Field } from "react-final-form";
import { withRouter } from "react-router-dom";

import { dismissLendingRequest, getNomenclatures } from "../store/request";
import { addAlert, removeModal } from "../store/app";
import Modal from "../components/Modal";
import { Textarea } from "../components/Form/Textarea";
import { Select } from "../components/Form/Select";
import Button from "../components/Button";
import { isRequired } from "../lib/validations";
import { parseNumberFormField } from "../lib/misc";

const NOMENCLATURES_REASONS = "reasons";

class DismissLendingModal extends Component {
  constructor(props) {
    super(props);

    const { type } = this.props;

    this.state = {
      isLoading: true,
    };

    // cancelLendingRequest or rejectLendingRequest
    this.modalName = `${type}LendingRequest`;
  }

  async componentDidMount() {
    const { dismissLendingReasons, getNomenclatures } = this.props;

    if (!dismissLendingReasons) {
      await getNomenclatures(NOMENCLATURES_REASONS);
    }

    this.setState({
      isLoading: false,
    });
  }

  handleDismissRequest = async (values) => {
    const { requestId, dismissLendingRequest, match, history, addAlert, type } =
      this.props;

    const response = await dismissLendingRequest(
      {
        reason: values.reason,
        comment: values.comment,
      },
      {
        requestId,
        actionType: type,
      },
    );

    if (response.ok) {
      this.handleRemoveModal();

      addAlert({
        message:
          type === "cancel"
            ? t`Request was cancelled`
            : t`Request was rejected`,
        variant: "success",
      });

      setTimeout(() => {
        history.push(`/${match.params.lendingType}`);
      }, 2000);
    }
  };

  handleRemoveModal = () => {
    const { removeModal, currentOpenModal } = this.props;

    // TODO: This should be done at router level if a modal is open
    if (currentOpenModal === this.modalName) {
      removeModal(this.modalName);
    }
  };

  componentWillUnmount() {
    this.handleRemoveModal();
  }

  getAvailableDismissReasons = () => {
    const { type, dismissLendingReasons } = this.props;

    return dismissLendingReasons
      ? dismissLendingReasons[NOMENCLATURES_REASONS].filter(
          (reason) => reason.type === type,
        )
      : [];
  };

  render() {
    const { type, requestId } = this.props;
    const { isLoading } = this.state;
    const dismissReasons = this.getAvailableDismissReasons();

    let modalHeader = type === "cancel" ? t`Cancel` : t`Reject`;
    modalHeader += ` #${requestId}`;

    return (
      <Modal id={this.modalName} header={modalHeader} width="md:w-2/5">
        {isLoading ? (
          <div className="min-h-200 flex items-center justify-center text-30">
            <div className="spinner" />
          </div>
        ) : (
          <div className="p-4">
            {dismissReasons.length > 0 && (
              <Form
                onSubmit={this.handleDismissRequest}
                render={(formProps) => {
                  const { handleSubmit } = formProps;

                  return (
                    <form onSubmit={handleSubmit}>
                      <div className="pb-5">
                        <Field
                          name="reason"
                          label={t`Reason`}
                          component={Select}
                          validate={isRequired()}
                          parse={parseNumberFormField}
                        >
                          <option value="">{t`Choose a reason`}</option>

                          {dismissReasons.map((reason) => (
                            <option
                              key={`reasons-select-${reason.id}`}
                              value={reason.id}
                            >
                              {reason.text}
                            </option>
                          ))}
                        </Field>
                      </div>
                      <div className="pb-5">
                        <Field
                          name="comment"
                          label={t`Comment`}
                          component={Textarea}
                        />
                      </div>

                      <Button
                        title={
                          type === "cancel"
                            ? t`Confirm cancellation`
                            : t`Confirm rejection`
                        }
                        color="red"
                        border={false}
                        fullWidth
                        onClick={handleSubmit}
                      />
                    </form>
                  );
                }}
              />
            )}
          </div>
        )}
      </Modal>
    );
  }
}

DismissLendingModal.propTypes = {
  type: PropTypes.oneOf(["reject", "cancel"]).isRequired,
  requestId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default withRouter(
  connect(
    (state) => ({
      dismissLendingReasons: state.request.nomenclatures[NOMENCLATURES_REASONS],
      currentOpenModal: state.app.modal,
    }),
    {
      dismissLendingRequest,
      getNomenclatures,
      addAlert,
      removeModal,
    },
  )(DismissLendingModal),
);
